import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ResetPasswordForm from './components/ResetPasswordForm/ResetPasswordForm';
import './ResetPasswordPage.scss';

const ResetPasswordPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    return (
        <div className="reset-password-page">
            <Helmet>
                <title>Réinitialisation du mot de passe | Soutien émotionnel des mamans | Aide à la parentalité | Montpellier</title>
            </Helmet>
            <div className="logo_container">
                <img src={'/assets/logo_transparent.png'} alt="logo" className="logo" loading="lazy" />
            </div>
            <ResetPasswordForm resetToken={token} onSuccess={() => navigate('/connexion')} />
        </div>
    );
};

export default ResetPasswordPage;